module.exports = __webpack_public_path__ + "img/sv81.59c8678e.svg";